import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';

import { ButtonWithIcon, Button, ButtonLink } from '@kyruus/button';
export const NavigationContainer = styled.div`
  position: absolute;
  top: ${fromTheme('spacing_large')};
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  z-index: 2;
  width: 100%;
  justify-content: space-between;
`;

export const StyledListButton = styled(ButtonLink)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: ${fromTheme('color_button_secondary')};
  border: ${fromTheme('border_width')} ${fromTheme('border_style')}
    ${fromTheme('color_border_secondary')};
  color: ${fromTheme('color_info')};
  padding: ${fromTheme('spacing_small')} ${fromTheme('spacing_medium')};
  border-radius: ${fromTheme('border_radius')};
  font-size: ${fromTheme('font_size')};
  font-weight: ${fromTheme('font_weight')};
  line-height: 21px;
  text-decoration: none;
  cursor: pointer;
  margin-left: ${fromTheme('spacing_large')};
`;

export const StyledSearchButton = styled(ButtonWithIcon)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background: ${fromTheme('color_background')};
  border: ${fromTheme('border_width')} ${fromTheme('border_style')}
    ${fromTheme('color_border_info')};
  color: ${fromTheme('color_info')};
  padding: ${fromTheme('spacing_small')} ${fromTheme('spacing_medium')};
  border-radius: ${fromTheme('border_radius')};
  font-size: ${fromTheme('font_size')};
  font-weight: ${fromTheme('font_weight')};
  line-height: 21px;
  cursor: pointer;
`;

export const StyledFiltersButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: ${fromTheme('color_button_secondary')};
  border: ${fromTheme('border_width')} ${fromTheme('border_style')}
    ${fromTheme('color_border_secondary')};
  color: ${fromTheme('color_info')};
  padding: ${fromTheme('spacing_small')} ${fromTheme('spacing_medium')};
  border-radius: ${fromTheme('border_radius')};
  font-size: ${fromTheme('font_size')};
  font-weight: ${fromTheme('font_weight')};
  line-height: 21px;
  cursor: pointer;
  margin-right: ${fromTheme('spacing_large')};
`;
